// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"247":"916763ea","511":"4baeebe4","641":"4eb0e61a","915":"b3ab38e4"}[chunkId] + ".chunk.css";
};